import ProtectedLayout from "layouts/Protected"
import HeaderBikeFleet from "./HeaderBikeFleet"

type LayoutBikeFleetProps = {
	children: React.ReactElement | React.ReactElement[]
}

export const LayoutBikeFleet: React.FC<LayoutBikeFleetProps> = ({ children }) => {
	return (
		<ProtectedLayout className="py-5 min-h-screen">
			<div className="l-container">
				<HeaderBikeFleet />
				{children}
			</div>
		</ProtectedLayout>
	)
}
